import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constant/AuthoriseAccountConstant';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';
// var cookie = require("public/js/cookie")

var CreatePortfolioAction = function () {

}

CreatePortfolioAction.prototype = {

	createPortfolio: function (data) {
		restClient.createPortfolio(data, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				} else {
					AppDispatcher.dispatch({
						actionType: Constant.CREATE_PORTFOLIO_ERROR,
						data: error
					});
				}
			} else {
				response.status = 200;
				AppDispatcher.dispatch({
					actionType: Constant.CREATE_PORTFOLIO_RESPONSE,
					data: response
				});
			}
		})
	}
}

export default new CreatePortfolioAction();